import React, { lazy } from 'react';
export function EmotionalOpening() {
  return <section className="bg-warm-light py-16 md:py-24 px-4" data-id="element-78">
      <div className="max-w-3xl mx-auto" data-id="element-79">
        {/* Section heading — text above the emotional image area */}
        <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-center text-warm-hero mb-4 leading-tight" data-id="element-80">
          You love your dog… so why do so many photos{' '}
          <span className="italic text-soft-gold" data-id="element-81">feel disappointing?</span>
        </h2>

        {/* Emotional image placeholder */}
        <div className="mb-8 rounded-2xl overflow-hidden shadow-lg max-w-2xl mx-auto" data-id="element-82">
          <img src="https://images.unsplash.com/photo-1530281700549-e82e7bf110d6?w=700&h=430&fit=crop&crop=faces&q=80" alt="Dog owner looking at disappointing phone photos of their dog" className="w-full h-auto object-cover" loading="lazy" decoding="async" width={700} height={430} data-id="element-83" />
        </div>

        {/* Emotional copy below image */}
        <div className="font-sans text-lg md:text-xl text-gray-800 space-y-5 leading-relaxed max-w-2xl mx-auto" data-id="element-84">
          <p data-id="element-85">
            You take the picture quickly. Your dog moves. The lighting looks
            wrong. The angle feels awkward. The background looks messy.
          </p>

          <p data-id="element-86">
            And somehow, the photo{' '}
            <span className="font-semibold" data-id="element-87">
              never captures how adorable they really are.
            </span>
          </p>

          <p data-id="element-88">
            Not because your dog isn't beautiful. Not because your phone isn't
            good enough.
          </p>

          <p data-id="element-89">
            But because{' '}
            <span className="font-semibold text-warm-hero" data-id="element-90">
              nobody ever showed you a simple, practical way to photograph your
              dog well.
            </span>
          </p>

          <p className="italic text-gray-600 border-l-4 border-soft-gold pl-5 py-3 my-6 bg-cream/60 rounded-r-lg" data-id="element-91">
            "That doesn't even capture how cute they really are."
          </p>

          <p className="font-semibold text-lg text-warm-hero" data-id="element-92">
            And honestly? That feeling sucks.
          </p>
        </div>
      </div>
    </section>;
}